import React,{useState} from 'react';
import './joincard.scss';
import ModalContact from './ModalContact';

function JoinCard() {
    const [visible, setVisible] = useState(false);
    return (
       <div className="join-card">
           <div className="title">赠你一张幸运邀请函！</div>
           <div className="desc">以上全套动效课程打包价：<span>1998</span>元，全程直播+回放！学会为止！</div>
           <button onClick={() => setVisible(true)}>现在报名</button>
           <div className="svg-motion"><img src="/images/svgmotion.svg" /></div>
           <div className="svg-motion2"><img src="/images/svgmotion2.svg" /></div>
           <div className="svg-motion3"><img src="/images/svgmotion.svg" /></div>
           <ModalContact
            visible={visible}
            onClose={()=>setVisible(false)}
          />
       </div>
    );
}

export default JoinCard;
